import React, { CSSProperties, FC, ReactNode } from 'react'
import { Button, TextContainer, ArrowsContainer, Arrow } from './style'
import ArrowIcon from '../../../assets/images/HalfArrow.svg'

interface SwipeButtonProps {
	onClick: () => void
	title?: string
	style?: CSSProperties
	width?: number | string
	moveTextLeft?: number
	noArrows?: boolean
	children?: ReactNode
}

export const SwipeButton: FC<SwipeButtonProps> = ({
	onClick,
	title = 'Начать',
	style,
	width,
	moveTextLeft = 0,
	children,
	noArrows = false,
}) => {
	return (
		<Button
			onClick={onClick}
			style={{
				width: width,
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				position: 'relative',
				cursor: 'pointer',
				...style,
			}}>
			<TextContainer
				style={{
					position: 'absolute',
					left: `calc(50% - ${moveTextLeft / 2}px)`,
					transform: 'translateX(-50%)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					height: '100%',
				}}>
				{children || title}
			</TextContainer>
			{!noArrows && (
				<ArrowsContainer
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						paddingTop: 3,
					}}>
					<Arrow $maxOpacity={0.5}>
						<img src={ArrowIcon} alt='Arrow' style={{ background: 'transparent' }} />
					</Arrow>
					<Arrow $maxOpacity={0.75}>
						<img src={ArrowIcon} alt='Arrow' style={{ background: 'transparent' }} />
					</Arrow>
					<Arrow $maxOpacity={1}>
						<img src={ArrowIcon} alt='Arrow' style={{ background: 'transparent' }} />
					</Arrow>
				</ArrowsContainer>
			)}
		</Button>
	)
}
